module.exports = __webpack_public_path__ + "static/media/ic_goal_inactive.69b8036e.svg";